var render, staticRenderFns
import script from "./BarChartComponent.vue?vue&type=script&lang=js&"
export * from "./BarChartComponent.vue?vue&type=script&lang=js&"
import style0 from "./BarChartComponent.vue?vue&type=style&index=0&id=6b8a1f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8a1f3a",
  null
  
)

export default component.exports